import { render, staticRenderFns } from "./CoreEditDialog.vue?vue&type=template&id=0a6fe327&scoped=true&"
import script from "./CoreEditDialog.vue?vue&type=script&lang=js&"
export * from "./CoreEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fe327",
  null
  
)

export default component.exports